import {
	Badge,
	BadgeSize,
	Button,
	ButtonSize,
	ColourStateOutline,
	FlexGap,
	PageHeader,
	StackHorizontal,
} from '@ukpostbox/frontend-framework';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import React from 'react';
import { MailboxActions } from './MailboxActions';
import { useMailbox } from '../Providers/NewMailboxProvider';
import { useMailboxesStore } from '../Providers/Stores/MailboxesStore';

function MailboxHeader() {
	const { ToggleCreateCustomFolderModal, UpdateActiveFolderData } = useMailbox();

	const mailBoxInfo = useMailboxesStore((state) => state.mailBoxInfo);

	return (
		<PageHeader
			title={mailBoxInfo.folderName}
			preTitleAddon={
				mailBoxInfo.customFolderId ? (
					<Badge colour={mailBoxInfo.folderColour} size={BadgeSize.Large} />
				) : undefined
			}
			postTitleAddon={
				mailBoxInfo.customFolderId ? (
					<Button
						icon={faPencil}
						iconOnly
						onClick={() => {
							UpdateActiveFolderData(mailBoxInfo.customFolderId as number);
							ToggleCreateCustomFolderModal(true);
						}}
						colour={ColourStateOutline.Secondary}
						size={ButtonSize.Small}
						title='Edit'
					/>
				) : undefined
			}
			secondaryHeader
			extraClass='mailbox-page-header'
		>
			<StackHorizontal gap={FlexGap.Small}>
				<MailboxActions />
			</StackHorizontal>
		</PageHeader>
	);
}

export { MailboxHeader };
